import React, { Fragment } from 'react';
import cancel1 from '../../../../images/cancel1.png';
import cancel2 from '../../../../images/cancel2.png';
import cancel3 from '../../../../images/cancel3.png';

const CancelBooking = () => (
  <Fragment>
    <p>
      On your Dashboard, you can cancel your upcoming booking by selecting
      “Cancel booking”.{' '}
    </p>
    <p>
      To cancel your future bookings, select “See all” to find the booking
      that you would like to cancel. When you find it, select the booking
      then select the 3 dots at the top right corner and you will see the
      option to cancel your booking. Please note that our flexible{' '}
      <a href="#what-is-your-cancellation-policy?">Cancellation Policy</a>{' '}
      will apply.
    </p>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img src={cancel1} style={{ width: '200px', height: '455px' }} />
      <img src={cancel2} style={{ width: '200px', height: '455px' }} />
      <img src={cancel3} style={{ width: '200px', height: '455px' }} />
    </div>
  </Fragment>
);

export default CancelBooking;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/MakingABooking/CancelBooking.js